/* Routes for the overview area (Area A: servers and onboarding). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'overview', lazy: page(() => import('./pages/OverviewPage')) }],
}
